import React from "react";
import { ordinalSuffix, toDateString } from "../../../common/helper";
import { usePrecandidateContext } from "../context/Context";
import IconNotes from "../../../layout/others/icon_notes.svg";
import { useTranslation } from "react-i18next";
import "./styles.scss";

const NotesHistory = () => {
  const { historyPreCandidate } = usePrecandidateContext();
  const { t } = useTranslation();

  return (
    <div>
      <nav>
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active"
              id="notes-tab"
              data-bs-toggle="tab"
              data-bs-target="#notes"
              type="button"
              role="tab"
              aria-controls="notes"
              aria-selected="true"
            >
              <img
                src={IconNotes}
                alt="ico-notes"
                height="14px"
                width="auto"
                style={{ marginRight: "4px" }}
              />
              {t("Notes")}
            </button>
          </li>
        </ul>
      </nav>
      <div className="tab-content" id="myTabContent">
        <div
          className="tab-pane fade show active"
          id="notes"
          role="tabpanel"
          aria-labelledby="notes-tab"
        >
          {historyPreCandidate.map((item) => {
            return (
              <div className={`history-notes ${item.entityType}`}>
                <div className="head">
                  <div id="entity-type">
                    <strong>
                      {`${item.entityNumber}`}
                      {ordinalSuffix(item.entityNumber) + " " + t(item.entityType)}
                    </strong>
                  </div>
                  <div
                    className="text-truncate"
                    id="username"
                    title={item.userName}
                  >
                    {item.userName}
                  </div>
                  <div id="created-date">{toDateString(item.createdDate)}</div>
                </div>
                {item.notes && (
                  <div id="notes">
                    <strong>{t("Notes") + ":"}</strong>
                    <div>{item.notes}</div>
                  </div>
                )}
                {item.entityType === "Attribution" && (
                  <div>
                    {t("CreatedBy") + ":"}
                    <div>{item.createdByUser}</div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default NotesHistory;
